import { parseSafeInt } from "Backend";
import { LoaderFunctionArgs, ShouldRevalidateFunction, redirect } from "react-router";
import { LoaderFunction, defer } from "react-router-typesafe";
import { fetchBookmarks } from "redux/slices/intakeViewer";
import store from "redux/store";

export const documentReviewLoader = (async (args: LoaderFunctionArgs) => {
  const caseId = parseSafeInt(args.params.caseId);
  const intakeId = parseSafeInt(args.params.documentId);

  if (caseId === undefined) {
    return redirect("..");
  }

  if (intakeId === undefined) {
    return null;
  }

  return defer({
    deferredBookmarks: store.dispatch(fetchBookmarks({ caseId, intakeId })).unwrap(),
  });
}) satisfies LoaderFunction;

export const shouldRevalidateDocumentReviewLoader: ShouldRevalidateFunction = (params) => {
  const { currentParams, nextParams } = params;
  return currentParams.documentId !== nextParams.documentId;
};
